
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 8c8.336 0 14.75 7.344 14.75 7.344l.594.656-.594.656s-5.849 6.668-13.625 7.281c-.372.047-.741.063-1.125.063s-.753-.015-1.125-.063C7.099 23.323 1.25 16.656 1.25 16.656L.656 16l.594-.656S7.664 8 16 8zm0 2c-2.228 0-4.282.618-6.063 1.438h.031a6.958 6.958 0 00-.969 3.563 6.995 6.995 0 006.219 6.969c.259.016.517.031.781.031.243 0 .48-.018.719-.031.021-.002.042.002.063 0A6.995 6.995 0 0023 15.001c0-1.325-.365-2.54-1-3.594-1.765-.805-3.798-1.406-6-1.406zm0 2a3 3 0 110 6 3 3 0 010-6zm-8.75.938a24.065 24.065 0 00-3.719 3.063 23.08 23.08 0 004.844 3.781A8.943 8.943 0 017 15.001c0-.714.092-1.392.25-2.063zm17.5 0c.157.665.25 1.348.25 2.063a8.943 8.943 0 01-1.375 4.781c2.52-1.455 4.27-3.195 4.844-3.781a24.065 24.065 0 00-3.719-3.063z"}})])
          )
        }
      }
    